/**
 * @generated SignedSource<<4f71e5883c80ca7de2300e346fa45323>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DetectedPeopleSection_account$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupRow_account">;
  readonly " $fragmentType": "DetectedPeopleSection_account";
};
export type DetectedPeopleSection_account$key = {
  readonly " $data"?: DetectedPeopleSection_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"DetectedPeopleSection_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "peopleFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DetectedPeopleSection_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "peopleFilter",
          "variableName": "peopleFilter"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProjectGroupRow_account"
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "01b14120877de0f84b4b5805e4227890";

export default node;
